import type { MightierSupportedLanguage } from "@neuromotion-inc/mightier-ts-sdk";

const makeWordpressLink = (
  urlPath: string,
  locale: MightierSupportedLanguage,
): string => {
  const parts = ["https://www.mightier.com"];
  // en doesn't need locale specified in URL
  if (locale !== "en") {
    parts.push(locale.toLowerCase());
  }

  parts.push(urlPath.startsWith("/") ? urlPath.substring(1) : urlPath);

  return parts.join("/");
};

const makeKnowledgeBaseLink = (
  urlPath: string,
  locale: MightierSupportedLanguage,
): string => {
  return [
    "https://support.mightier.com/hc",
    getKnowledgeBaseLocale(locale.toLowerCase()),
    urlPath.startsWith("/") ? urlPath.substring(1) : urlPath,
  ].join("/");
};

// Zendesk knowledge base locales are different from i18n locales
const getKnowledgeBaseLocale = (locale: string): string => {
  if (locale === "en") {
    return "en-us";
  } else if (locale === "uk") {
    return "uk-ua";
  } else {
    return locale;
  }
};

export const staticLinks = {
  faqs: (lng: MightierSupportedLanguage): string => {
    return makeKnowledgeBaseLink("", lng);
  },
  contactPage: (lng: MightierSupportedLanguage): string => {
    return makeWordpressLink("contact-us/", lng);
  },
  termsOfService: (lng: MightierSupportedLanguage): string => {
    return makeWordpressLink("terms-of-use/", lng);
  },
  privacyPolicy: (lng: MightierSupportedLanguage): string => {
    return makeWordpressLink("privacy-policy/", lng);
  },
  welcome: (lng: MightierSupportedLanguage): string => {
    return makeWordpressLink("welcome", lng);
  },
  enterpriseWelcome: (lng: MightierSupportedLanguage): string => {
    return makeWordpressLink("experience", lng);
  },
  loginToHub: "https://hub.mightier.com/login/",
  facebook: "https://www.facebook.com/bemightier/",
  x: "https://twitter.com/mightier_",
  linkedin: "https://www.linkedin.com/company/mightier/posts/",
};
